import MapWrapper from "components/MapWrapper/MapWrapper";
import LotsMapMarker from 'features/maps/markers/LotsMapMarker/LotsMapMarker';
import { useTitle } from "hooks/useTitle";

const LotsMap = ({ lots, handleSelectLot, isNarrowScreen }) => {

    useTitle('Lots Map');

    function getCenterPoint(points) {
        if (!points || points.length === 0) return null;

        const total = points.reduce(
            (acc, point) => ({
                lat: acc.lat + point.lat,
                lng: acc.lng + point.lng,
            }),
            { lat: 0, lng: 0 }
        );

        return {
            lat: total.lat / points.length,
            lng: total.lng / points.length,
        };
    }

    const defaultProps = {
        center: {
            lat: 23.030175,
            lng: -101.763726
        },
        zoom: 4
    };

    const lotPoints = lots?.map(l => ({lat: +l.latitude, lng: +l.longitude}));
    const mapCenter = lotPoints?.length ? getCenterPoint(lotPoints) : defaultProps.center;

    console.log('lots', lots);
    console.log('lotPoints', lotPoints);
    console.log('mapCenter', mapCenter);


    let markers = lots?.map(lot => {
        return {
            ...lot,
            address: lot.addressLine1 + ', ' + lot.city + ', ' + lot.state,
            icon: <LotsMapMarker
                lot={lot}
                color={lot.ownedByTenant ? "#0090FE" : "#E48900"}
                text={lot.name}
            />,
            onClick: handleSelectLot,
            id: lot?.id
        }
    })

    return (
        <MapWrapper
            defaultCenter={mapCenter}
            defaultZoom={defaultProps.zoom}
            markers={markers}
            includeSearch
            isNarrowScreen={isNarrowScreen}
        />
    )
}

export default LotsMap;